import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import PropTypes from 'prop-types';

import { SubmitSpinner } from '../../ui';
import Button from '../../ui/button';
import { Spinner } from '../../ui/icon';

const OrderSubmitButton = ({ disabled, customer, requestText, submitText, loginText }) => {
  const { input } = useField('showWriter');
  const { input: loginAbility } = useField('login_ability');
  const authenticated = useMemo(() => !!customer.email, [customer.email]);
  const getText = () => {
    switch (true) {
      case loginAbility.value && !authenticated:
        return loginText;
      case input.value:
        return requestText;
      default:
        return submitText;
    }
  };
  return (
    <Button
      disabled={disabled}
      type="submit"
    >
      {disabled && (
        <SubmitSpinner>
          <Spinner
            width="19.5"
            height="19.5"
          />
        </SubmitSpinner>
      )}
      {!disabled && getText()}
    </Button>
  );
};

OrderSubmitButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  requestText: PropTypes.string.isRequired,
  submitText: PropTypes.string.isRequired,
  customer: PropTypes.shape({}).isRequired,
};

export default OrderSubmitButton;
